import './module/common';
import './module/menu';
//import './module/swiper';
import './module/splide';
import './module/faq';
import './module/pattern';
import './module/objfix';
import './module/report';
//import './module/tabpanel';
import './module/shuffle';
import './module/inview';
import './module/scrollhint';
import './module/movie-popup';
import './module/switch';
import './module/accordion';
